import api from '@/services/utils/base';
import { Component, Vue } from 'vue-property-decorator';

import store from '@/store';
import router from '@/routes';
import boot from '@/services/utils/boot';
import CurrencyApi from '@/services/rest/bemob/currency';
import DictionaryApi from '@/services/rest/bemob/dictionary';
import UserAPI from '@/services/rest/bemob/user';
import ReportAPI from '@/services/rest/bemob/report';
import TimezoneAPI from '@/services/rest/bemob/timezone';
import OffersAPI from '@/services/rest/bemob/offer';
import LandingsAPI from '@/services/rest/bemob/landing';
import UserApi from '@/services/rest/bemob/user';
import ColumnSettingsApi from '@/services/rest/bemob/column-settings';
import ColumnsGroupsSettingApi from '@/services/rest/bemob/columns-groups-setting';
import CustomColumnsApi from '@/services/rest/bemob/custom-columns';
import CustomConversionsApi from '@/services/rest/bemob/custom-conversions';
import BillingApi from '@/services/rest/bemob/billing';
import query from '@/components/query/query-constructor';
import { AppErrorEnum } from '../models/Enums';
import ColumnsService from '@/services/columns';
import _, { get } from 'lodash';
import { switchDesktopMobileView } from '@/routes/hooks/desktop-view-forced';
import { getUserDataFromLocalStorage } from '@/services/localStorage-users-data';

const currencyApi: CurrencyApi = new CurrencyApi();
const dictionaryApi: DictionaryApi = new DictionaryApi();
const userApi: UserAPI = new UserAPI();
const reportApi: ReportAPI = new ReportAPI();
const timezoneApi: TimezoneAPI = new TimezoneAPI();
const offersApi: OffersAPI = new OffersAPI();
const landingsApi: LandingsAPI = new LandingsAPI();
const columnSettingsApi: ColumnSettingsApi = new ColumnSettingsApi();
const columnsGroupsSettingApi: ColumnsGroupsSettingApi = new ColumnsGroupsSettingApi();
const customColumnsApi: CustomColumnsApi = new CustomColumnsApi();
const customConversionsApi: CustomConversionsApi = new CustomConversionsApi();
const billingApi: BillingApi = new BillingApi();
import { GENERAL_PRESET } from '@/services/constants/report';

const tableQueryDefault = {
  'orderDir':'desc',
  'orderBy':'reports-visits',
  'from':'2019-04-01 00:00:00',
  'to':'2019-04-01 23:59:59',
  'date':'today',
  'limit':50,
  'status':'active',
  'currency':'USD',
  'offset':0,
  'columns': [
    'campaigns-name',
    'reports-visits',
    'reports-visitsuniq',
    'reports-clicks',
    'reports-clicksuniq',
    'reports-conversionconfirm',
    'reports-revenue',
    'reports-cost',
    'reports-profit',
    'reports-cpv',
    'reports-cpc',
    'reports-ctr',
    'reports-1xctr',
    'reports-uctr',
    'reports-cr',
    'reports-1xcr',
    'reports-cv',
    'reports-1xcv',
    'reports-roi',
    'reports-epv',
    'reports-epc',
    'reports-ap'
  ],
  'groupBy':'campaigns',
  'formatResponse':1,
  'timezone':'UTC',
};

const dashboardQueryDefault = {
  'date':'today',
  'status':'active',
  'currency':'AUD',
  'orderBy':'reports-profit',
  'sortBy':'reports-profit',
  'orderDir':'desc',
  'from':'2019-04-01 00:00:00',
  'to':'2019-04-01 23:59:59',
  'direction':'desc',
  'columns':['reports-profit'],
  'groupBy':'campaigns',
  'timezone':'UTC',
  'formatResponse':1,
  'limit':5,
  'offset':0
}

const { loader } = window as any;
import columns from '@/services/columns';
import { setupWebsocket } from '@/services/utils/websocket';
import { getConversionsMetrics } from '@/views/reports/pickers/base/conversions/columns';

export interface LoginOptions {
  showLoader?: boolean;
  redirect?: boolean;
}

@Component
export default class BemobApi extends Vue {
  state: Object = {
    recaptcha: ''
  };

  profile!: any;

  get userApi() {
    return new UserApi();
  }

  getDefaultLoginOptions(): LoginOptions {
    return {
      showLoader: true,
      redirect: true
    };
  }

  async login(data: any, options: LoginOptions = {}) {
    options = {
      ...this.getDefaultLoginOptions(),
      ...options
    };

    const request = {
      ...data,
      site_id: this.$config.api.site_id
    };

    if (options.showLoader) {
      loader.show();
    }

    try {
      let res = await api.post('auth/login', request);
      api.setAuthToken(res.data.payload.id);

      if (res.data.payload.ttl == 0) {
        return router.push('/two-factor');
      }

      await this.loadProfileData(options);
      store.commit('login');

      if (options.redirect) {
        router.push(this.getDashboardLink(this.profile));
      }

      return Promise.resolve(res);
    } catch (err) {
      if (options.showLoader) {
        loader.hide();
      }

      return Promise.reject(err);
    }
  }

  loginExternal(code: string) {
    api.setAuthToken(code);
    return Promise.resolve();
  }

  removeAuthToken() {
    api.removeAuthToken();
  }

  async loginSupport(data: { userId: string; password: string; recaptchaResponse: string }) {
    loader.show();

    try {
      let res = await api.post('auth/login/support', data);

      if (store.state.isAuthenticated) {
        store.commit('logout');
      }

      api.setAuthToken(res.data.payload.id);
      if (res.data.payload.ttl == 0) {
        return router.push('/two-factor');
      }

      await this.loadProfileData();
      store.commit('login');

      router.push(this.getDashboardLink(this.profile));

      return Promise.resolve(res);
    } catch (err) {
      loader.hide();
      return Promise.reject(err);
    }
  }

  async forgotPassword(data: object) {
    const request = {
      ...data,
      site_id: this.$config.api.site_id
    };
    return await api.post('auth/forgot-password', request);
  }

  async register(data: object) {
    const request = {
      ...data,
      site_id: this.$config.api.site_id
    };

    try {
      let res = await api.post('auth/register', request);
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async checkToken(data: object) {
    try {
      let payload = await userApi.postTwoFactorAuth(data);
      return Promise.resolve(payload);
      // if(payload.result === true) {
      //   return this.loadProfileData().then(() => {
      //     store.commit('login');
      //   });
      // } else {
      //   return Promise.reject();
      // }
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async loadProfileData(options: LoginOptions = {}) {
    options = {
      ...this.getDefaultLoginOptions(),
      ...options
    };

    setupWebsocket()

    if (options.showLoader) {
      loader.show();
    }

    try {
      const { isMember, emailVerified } = await this.getUserProfile();

      let promises = [
        reportApi.getSupportedDimensions,
        reportApi.getSupportedMetrics,
        this.getColumnSettings,
        columnsGroupsSettingApi.getColumnsGroupsSetting,
        this.getAcl,
        this.getCurrencyList,
        this.getCountryList,
        this.getTimezoneList,
      ];

      // plans should be before subscription
      if (!isMember) {
        promises.push(this.getPlans, billingApi.getAddons)
      }
      
      if (emailVerified) {
        promises.push(billingApi.getSubscriptions)
      }

      // if(!twoFactorProbe) {
      //   promises.unshift(this.getUserProfile);
      // }

      const data = await boot(promises);

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      store.commit('isProfileLoaded', true);
      store.commit('loading', false);

      if (options.showLoader) {
        loader.hide();
      }
    }
  }

  async getUserProfile() {
    try {
      const res = await userApi.getUser();
      const { workspaces } = res;
      const workspaceIds = (workspaces && workspaces.map((workspace: any) => workspace.id)) || [];

      const userDataFromLocalStorage = getUserDataFromLocalStorage(res.id);
      const savedSelectedWorkspaces = userDataFromLocalStorage.selectedWorkspaces || [];
      const savedWorkspaces = userDataFromLocalStorage.workspaces || [];

      const selectedWorkspace = savedWorkspaces
        ? savedSelectedWorkspaces.filter((workspaceId: string) => workspaceIds.includes(workspaceId)) ||
          workspaceIds
        : workspaceIds;

      res.selectedWorkspaces = [...selectedWorkspace];

      store.commit('login', res);
      this.profile = res;

      //const localStorageUserData = ColumnsService.localStorageUserData;
      const userData = ColumnsService.currentUserData;

      if (this.profile.hasUnpaidInvoices) {
        store.commit('appError', AppErrorEnum.unpaidInvoices);
      }

      if (userDataFromLocalStorage.desktopViewForced) {
        store.commit('mobileDesktopViewForced', userDataFromLocalStorage.desktopViewForced);
        switchDesktopMobileView(userData.desktopViewForced);
      }

      if (userDataFromLocalStorage.bookmarks) {
        store.commit('initBookmarks', userDataFromLocalStorage.bookmarks);
      }
      return Promise.resolve(res);
    } catch (err) {
      const message = get(err, 'response.data.message', null);
      if (message === 'VALIDATE_EMAIL') {
        store.commit('logout');
      }
      return Promise.reject(err);
    }
  }

  async getCurrencyList() {
    try {
      const payload = await currencyApi.getList({});
      store.commit('getCurrencyList', payload);
      return Promise.resolve(payload);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async getPlans() {
    try {
      const payload = await billingApi.getPlans();
      store.commit('setBillingPlans', payload);
      return Promise.resolve(payload);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async getCountryList() {
    try {
      const payload = await dictionaryApi.get('countries');
      store.commit('getCountryList', payload);
      return Promise.resolve(payload);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async getTimezoneList() {
    try {
      const payload = await timezoneApi.getList({});
      store.commit('getTimezoneList', payload);
      return Promise.resolve(payload);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  getCustomColumns() {
    return customColumnsApi.get().then(customColumns => {
      store.commit('customColumns', customColumns);
    });
  }

  async getColumnSettings() {
    try {
      const userData = ColumnsService.currentUserData;

      const getColumnSettingsPromise = columnSettingsApi.getColumnSettings();
      const getCustomConversionsPromise = customConversionsApi.get();
      const getCustomColumnsPromise = customColumnsApi.get();

      let [columnSettings, customEvents, customColumns] = await Promise.all([
        getColumnSettingsPromise,
        getCustomConversionsPromise,
        getCustomColumnsPromise
      ]);      
      store.commit('tableCustomEvents', customEvents);
      store.commit('customColumns', customColumns);
      
      if (columnSettings.length === 0) {
        const payload = (Object.values(store.getters.getDefaultColumns) as ColumnsSettingsContext[]).map((column) => {
          const { context } = column
          const { width, order } = column

          const columnsWidth = Object.entries(width).map(([key, value])=> ({
            name: key,
            width: value,
          }))

          return {
            columns: columnsWidth,
            context,
            order,
          }
        }) as ColumnsSettingsContextServerFormat[]

        await columnSettingsApi.putColumnSettings({
          id:GENERAL_PRESET,
          settings:payload
        });

        store.dispatch('setSavedColumns', [{
          id:GENERAL_PRESET,
          name:null,
          settings:payload
        }])
      }else{
        store.dispatch('setSavedColumns', columnSettings)
      }
      
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  }

  putProfile(payload: any) {
    return api
      .put('user', payload)
      .then((res: any) => {
        return Promise.resolve(res.data);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  getDashboardLink(profile: any) {
    let date = new Date().toISOString().replace(/T(.*)$/gi, '');
    const currency = profile.currencyId || 'USD';
    let data = profile.defaultHomepage === 'campaigns' ? tableQueryDefault : dashboardQueryDefault;

    data.from = date + ' 00:00:00';
    data.to = date + ' 23:59:59';
    data.currency = currency;
    data.timezone = profile.defaultTimezone;

    if (profile.defaultHomepage !== 'campaigns') {
      data.orderDir = profile.dashboardDefaultOrderDir;
      data.orderBy = profile.dashboardDefaultGroup;
    }

    return profile.defaultHomepage === 'campaigns'
      ? `/app/report/campaigns/${query.encode(data)}`
      : `/app/dashboard/${query.encode(data)}`;
  }

  async getAcl() {
    try {
      let acl = null;

      if (store.state.user && store.state.user.isMember && store.state.user.id) {
        acl = await this.userApi.getMemberAcl({
          userId: store.state.user.id,
          workspaceIds: store.state.user.allWorkspaces
        });

        let aclNormalized: any = {};
        acl.forEach((item: any) => (aclNormalized[item.workspaceId] = item));

        store.commit('saveUserAcl', aclNormalized);

        const res = await this.userApi.getMember(store.state.user.id);
        const member = res.data.payload;
        store.commit('member', member);
      }

      return Promise.resolve(acl);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  async memberLogin(data: Bemob.MemberLoginViewModel) {
    const request = {
      ...data,
      site_id: this.$config.api.site_id
    };

    try {
      const res = await api.post('auth/login/member', request);

      const twoFactorQrCode = get(res, 'data.payload.twoFactorQrCode');
      if (twoFactorQrCode) {
        store.commit('member', { twoFactorQrCode });
      }

      if (store.state.isAuthenticated) {
        store.commit('logout');
      }

      api.setAuthToken(res.data.payload.id);
      if (res.data.payload.ttl == 0) {
        return router.push('/two-factor');
      }

      loader.show();
      await this.loadProfileData();
      store.commit('login');

      router.push(this.getDashboardLink(this.profile));

      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  }

  validate<T>(entity: string, validation: string, value: T): Promise<Bemob.ValidationResult<T>> {
    const query = `/${entity}/validation/${validation}`;
    return api
      .post(query, { value })
      .then((res: Bemob.ValidationResponse<T>) => {
        return Promise.resolve(res.data);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  resendVerificationEmail() {
    return api
      .post('/auth/resend-activation-email')
      .then(res => {
        return Promise.resolve(res);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }
}
